import { BaseStore } from '@/stores/baseStore';
import indexedDB from '@/commons/indexedDB';

import { ModuleAccount } from './moduleConst';
import commonFn from '@/commons/commonFunction.js';
import _ from 'lodash';

// TODO => hoàn thiện các action trên chứng từ
export class BaseDictionaryStore extends BaseStore {
  constructor(api) {
    super(api);
    this.action = {
      ...this.action,
      ...{
        /**
         * Xử lý load về tất cả các cache về danh mục
         * @param {*} payload
         * npcuong 27.04.2023
         * ntchuyen 12.09.2025 sửa có trường hợp gọi indexedDB bị lỗi
         */
        async loadFullCache(payload) {
          const config = this._config;
          const name = `di_cache_${this.$id}`;

          // Kiểm tra xem module này cấu hình cache hay ko
          const indexDb = new indexedDB();
          const key = name;

          // Thử get data từ IndexedDB
          let data;
          try {
            data = await indexDb.get(key);
          } catch (storageError) {
            console.warn(`IndexedDB không khả dụng cho ${this.$id}, fallback to API:`, storageError);
            // Fallback: load trực tiếp từ API mà không cache
            const remoteData = await this.getFullListCustom();
            this.items = remoteData;
            return;
          }

          if (data) {
            const { localVersion, localData } = data;
            // Nếu version khác nhau thì thực hiện load lại full dữ liệu
            if (localVersion !== payload.remoteVersion) {
              const remoteData = await this.getFullListCustom();

              await indexDb.set(key, {
                localVersion: payload.remoteVersion,
                localData: remoteData,
              });
              this.items = remoteData;
            } else {
              this.items = localData;
            }
          } else {
            const remoteData = await this.getFullListCustom();
            await indexDb.set(key, {
              localVersion: payload.remoteVersion,
              localData: remoteData,
            });
            this.items = remoteData;
          }

          this.executeAfterLoadFullCache();
        },

        executeAfterLoadFullCache() { },

        //  Load dữ liệu cho phép override chỉnh sửa payload
        async getFullListCustom() {
          const config = this._config;
          const defaultSort = config.defaultSort ? config.defaultSort : config?.field?.code;

          var payload = {
            columns: config.columns ? config.columns : "*",
            sort: defaultSort,
          };

          return await this.getFullList(payload);
        },

        /**
         * Cập nhật trạng thái theo dõi, ngừng theo dõi
         * @param {*} context
         * @param {*} param
         * @return
         * npcuong 27.04.2023
         */
        async followState(param) {
          const res = await api.quickUpdateFollowState(param || {});
          if (res) {
            // cập nhật danh sách
            const payload = { data: res, value: param.Value };
            this.updateItemQuickFollow(payload);
          }
          return res;
        },

        /**
         * Cập nhật khi sửa bản ghi
         * NXCHIEN 07.06.2022
         */
        updateItemQuickFollow(payload) {
          const items = this.items;
          const quickField = this._config.quickFollow;
          const keyField = this._config.key;
          const data = payload.data;
          const value = payload.value;

          if (data && data.length) {
            for (let i = 0; i < data.length; i++) {
              if (keyField && quickField) {
                const id = data[i];
                const objValue = {};
                objValue[quickField] = value;

                for (let j = 0; j < items.length; j++) {
                  const item = items[j];

                  if (item[keyField] === id) {
                    item[quickField] = objValue[quickField];
                  }
                }
              }
            }
          }
        },

        /**
         * Cập nhật dữ liệu khi chuyển danh mục
         */
        async updateTranferData(payload) {
          const me = this;
          const res = await api.UpdateTranferData(payload || {});
          if (res) {
            if (payload.State == 0) {
              // context.commit('insertItem', payload.ToData);
              if (res) {
                me.items = [payload.ToData, ...me.items];
              }
            } else if (payload.State == 1) {
              this.updateItem(payload.ToData);
            }
          }
          return res;
        },
      },

      /**
       * Lấy 1 bản ghi theo id từ dữ liệu cache
       * bvbao 02.06.2023
       */
      getDataLocalByIds(id) {
        return this.items.find(x => x[this._config.key] === id);
      },

      /**
       * @description Lấy ra những bản ghi không phải con của bản ghi truyền vào và sắp xếp lại theo màn danh sách
       * @author nmduc1 26.07.2023
       */
      notChildItems: function (id) {
        const me = this;
        let result = [];
        //Nếu không phải dạng tree thì trả về toàn bộ
        if (!me._config.isTree) {
          result = me.items;
        } else {
          // Tìm những bản ghi là con của bản ghi hiện tại
          let childs = commonFn.findChildsByField(me.sortTreeItems, id, me._config.key, null, true);

          //Nếu không có con thì trả về toàn bộ
          if (!childs || childs.length == 0) {
            result = this.sortTreeItems;
          } else {
            // Clone để tránh ghi đè this.items trong hàm sortAsTree
            let tmpdata = _.cloneDeep(me.sortTreeItems);
            // Lọc ra những bản ghi không phải con
            result = tmpdata.filter(
              item => !childs.some(childItem => childItem[me._config.key] === item[me._config.key]),
            );
          }
        }

        return result;
      },
    };

    this.getters = {
      /**
       * Lấy toàn bộ item đang active
       * @returns Array
       */
      activeItems: function () {
        return this.items.filter(x => x.active);
      },

      /**
       * Sắp xếp lại dữ liệu dạng tree
       * @returns Array
       */
      sortTreeItems: function () {
        if (!this._config.isTree) {
          return this.items;
        } else {
          // Clone để tránh ghi đè this.items trong hàm sortTree
          let tmpdata = _.cloneDeep(this.items);
          //VDDONG 13/12/2023: Nếu trong store có config dataOrigin thì sẽ lấy dataOrigin
          // if (this._config.hasDataOrigin) {
          //   tmpdata = _.cloneDeep(this.itemsOrigin);
          // }
          let result = commonFn.sortAsTree(tmpdata, this._config.key, 'parent_id', true);
          return result;
        }
      },

      /**
       * Sắp xếp lại và lấy những bản ghi còn theo dõi
       * @returns Array
       */
      sortTreeActiveItems: function () {
        if (!this._config.isTree) {
          return this.items;
        } else {
          // Clone để tránh ghi đè this.items trong hàm sortTree
          let tmpdata = _.cloneDeep(this.items);
          let result = commonFn.sortAsTree(tmpdata, this._config.key, 'parent_id', true);
          return result.filter(x => x.active);
        }
      },
    };
  }
}
